export default __webpack_public_path__ + "static/media/section2_right.cb01516d.png";